import { render, staticRenderFns } from "./SearchHelp.vue?vue&type=template&id=7063c375&scoped=true&lang=pug&"
import script from "./SearchHelp.vue?vue&type=script&lang=js&"
export * from "./SearchHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7063c375",
  null
  
)

export default component.exports